import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=49b1233a&scoped=true&"
import script from "./MainTitle.vue?vue&type=script&lang=js&"
export * from "./MainTitle.vue?vue&type=script&lang=js&"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=49b1233a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1233a",
  null
  
)

export default component.exports